import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
  List,
  Container,
} from "@chakra-ui/react";
import Images from "../Components/Images";
import CustomListItem from "../Components/CustomListItem";
import FAQs from "../Components/FAQs";
import LandingLayout from "../Layouts/LandingLayout";

function LandingPage() {
  return (
    <LandingLayout>
      <Box
        backgroundImage={{
          base: "none",
          lg: `url(${Images.ConfettiBackground})`,
        }}
        backgroundRepeat="no-repeat"
        backgroundOrigin="content-box"
        backgroundPosition="top -500px right -450px"
      >
        <Flex
          justify={{ base: "center", lg: "space-between" }}
          align="center"
          my={{ base: "5rem", lg: "2rem" }}
        >
          <Box textAlign={{ base: "center", lg: "left" }} ml="2rem">
            <Heading mb="1rem" fontWeight="600" size="3xl">
              A convenient way of <br /> fulfilling your wishlist
            </Heading>

            <Text mb="1rem">
              Recieve promises from friends & families then withdraw <br />{" "}
              promises from your personalized wallet
            </Text>

            <Button
              bg="brand.900"
              color="white"
              variant="solid"
              colorScheme="brand.900"
              padding="1.5rem"
              boxShadow="-10px 10px 20px 0px #d4c2ec"
            >
              Get Started
            </Button>
          </Box>

          <Box display={{ base: "none", lg: "block" }}>
            <Image maxW="500px" src={Images.LandingImage} alt="Promise Card" />
          </Box>
        </Flex>
        <Container maxW="container.xl" textAlign="center">
          <Heading textAlign="center">
            How <Box display="inline">PromiseCard</Box> Works
          </Heading>

          <Flex
            mb="2rem"
            justify={{ base: "center", lg: "space-between" }}
            flexWrap="wrap"
          >
            <Box mx="2rem">
              <Image src={Images.billyPointingPhone} alt="how it works" />
              <Box my="1rem">
                <Heading size="lg" mb=".5rem">
                  Sign in
                </Heading>
                <Text>
                  Login or Create a free <br /> account to get started
                </Text>
              </Box>
            </Box>
            <Box mx="2rem">
              <Image src={Images.billyPointingReport} alt="how it works" />
              <Box my="1rem">
                <Heading size="lg" mb=".5rem">
                  Make Wishlist
                </Heading>
                <Text>
                  Create a promise card and <br /> include your wishlist
                </Text>
              </Box>
            </Box>
            <Box mx="2rem">
              <Image src={Images.billyChatting} alt="how it works" />
              <Box my="1rem">
                <Heading size="lg" mb=".5rem">
                  Share & Earn
                </Heading>
                <Text>
                  Share your wishlist with <br /> friends and get them fulfilled
                </Text>
              </Box>
            </Box>
          </Flex>
        </Container>

        <Container maxW="container.lg">
          <Box>
            <Flex justify="space-between" align="center" flexWrap="wrap">
              <Image src={Images.billyTakingNotes} alt="create promise card" />
              <Box>
                <Heading>Create your PromiseCard</Heading>
                <Text my=".8rem">
                  Create a wishlist for the season, your birthday, anniversary{" "}
                  <br /> or just any event you can think of.
                </Text>

                <List spacing={5}>
                  {[
                    "Give your wishlist a custom title",
                    "Add all kinds of stuffs to your wishlist; even hugs",
                    "You can create multiple wishlists.",
                  ].map((item, index) => (
                    <CustomListItem key={index}>{item}</CustomListItem>
                  ))}
                </List>
              </Box>
            </Flex>
            <Flex justify="center">
              <Image src={Images.RightDownArrow} alt="down right arrow" />
            </Flex>
          </Box>
          <Box>
            <Flex justify="space-between" align="center" flexWrap="wrap">
              <Box>
                <Heading>Share and Earn</Heading>
                <Text my=".8rem">
                  Share your promise card link or ID to friends and family{" "}
                  <br /> and watch your wishes come true. How cool is that
                </Text>

                <List spacing={5}>
                  {[
                    "Promises can be paid directly to your promise card.",
                    "Friends can pay whenever they want, no pressure.",
                    "Reminders are sent to friends who promise to fulfill your wishes.",
                  ].map((item, index) => (
                    <CustomListItem key={index}>{item}</CustomListItem>
                  ))}
                </List>
              </Box>
              <Image src={Images.billyOnRocket} alt="create promise card" />
            </Flex>
            <Flex justify="center">
              <Image src={Images.LeftDownArrow} alt="down left arrow" />
            </Flex>
          </Box>
          <Box>
            <Flex
              justify="space-between"
              mb="2rem"
              align="center"
              flexWrap="wrap"
            >
              <Image src={Images.billyOnPiggyBank} alt="create promise card" />

              <Box>
                <Heading>Withdraw your Promises</Heading>
                <Text my=".8rem">
                  withdraw fulfilled wishes by friends and family from your{" "}
                  <br />
                  personalized wallet
                </Text>

                <List spacing={5}>
                  {[
                    "Promises are readily available in your wallet.",
                    "Wallet funds can be withdawn at any time.",
                    "Get Credited in minutes upon withdrawal.",
                  ].map((item, index) => (
                    <CustomListItem key={index}>{item}</CustomListItem>
                  ))}
                </List>
              </Box>
            </Flex>
          </Box>
          <Box mb="4rem">
            <FAQs />
          </Box>
        </Container>
      </Box>
    </LandingLayout>
  );
}

export default LandingPage;
